
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2a1a6b6e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DeleteCategory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DeleteCategory.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2a1a6b6e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DeleteCategory.vue"),
  /* scopeId */
  "data-v-2a1a6b6e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/DeleteCategory.vue
// module id = ./dev/src/components/DeleteCategory.vue
// module chunks = 0